<template>
  <div class="yunxiao class new-add-paike">
    <div class="main">
      <div class="desc-top">
        系统支持冲突检测，自动检索课程表中存在的时间、教室、老师冲突，避免撞课。<span style="color: var(--c1)" @click="$router.push({
        name: 'help-page',
        params: {
          src:'https://bangzhu.xiaogj.com/yxhelp-list/detail-8.html'
        }
      })">查看操作说明</span>
      </div>
      <van-form input-align="right">
        <van-field label="排课类型" v-if="!classId && formPage !== 'reserve'" :border="false">
          <template #input>
            <div class="paike-type-btns">
              <div :class="{ active: coursePlanType === 1 }" @click="changeCoursePlanType(1)">
                按学员
              </div>
              <div :class="{ active: coursePlanType === 0 }" @click="changeCoursePlanType(0)">
                按班级
              </div>
            </div>
          </template>
        </van-field>
        <!-- 带classId表示从班级进入，班级需要直接置顶-->
        <van-cell
          class="van-cell--required"
          :class="{ block: !classId }"
          title="班级"
          title-class="abc"
          style="margin-bottom: calc(var(--gap) * 12)"
          is-link
          v-if="coursePlanType === 0"
          :border="false"
          @click="selectClass"
        >
          <template>
            <div v-if="classInfo.id">
              <div class="l1 van-ellipsis" :class="{ gray: this.classId }">
                {{ classInfo.className }}
              </div>
            </div>
            <div style="color: var(--g5)" v-else>请选择</div>
          </template>
        </van-cell>
        <div class="block" v-else>
          <van-cell title="校区" title-class="abc" required is-link @click="chooseCampus">
            <template>
              <div v-if="params.campusId" style="color: var(--g8)">
                {{ params.campusName }}
              </div>
              <div v-else style="color: var(--g5)">请选择</div>
            </template>
          </van-cell>
          <van-field
            name="radio"
            label="排课方式"
            :border="false"
            required
            v-if="this.formPage !== 'reserve'"
          >
            <template #input>
              <van-radio-group v-model="coursePlanMode" direction="horizontal" @change="changeCoursePlanMode">
                <van-radio :name="0">先选课程</van-radio>
                <van-radio :name="1">先选学员</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 排课方式：先选课程 -->
          <paike-course-first
            v-if="coursePlanMode == 0"
            :params="params"
            :formPage="formPage"
            :campusList="campusList"
            @change="courseStudentChange"
            ref="paikeCourseFirstRef"
          ></paike-course-first>
          <!-- 排课方式：先选学员 -->
          <paike-student-first
            v-if="coursePlanMode == 1"
            :params="params"
            :campusList="campusList"
            @change="courseStudentChange"
            ref="paikeStudentFirstRef"
            ></paike-student-first>
        </div>
        <div class="block linear-gradient">
          <van-field
            v-if="!isQuick"
            name="radio"
            :label="formPage !== 'reserve' ? '排课规则' : '约课时段'"
            :border="false"
            required
          >
            <template #input>
              <van-radio-group v-model="params.courseTimeType" direction="horizontal">
                <van-radio :name="1">按天</van-radio>
                <van-radio :name="0">按周</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <!-- 按天排课 排课时段类型 0:按周设置 1:按天设置 -->
        <paike-date
          :isQuick="isQuick"
          v-if="params.courseTimeType === 1"
          v-model="dailyPlanDetailList"
          ref="paikeDate"
        />
        <!--按周排课-->
        <week-paike-date
          v-if="params.courseTimeType === 0"
          v-model="weeklyPlanDetailList"
          ref="weekPaikeDate"
        />
        <div class="block">
          <van-field
            readonly
            clickable
            input-align="right"
            label="上课老师"
            placeholder="请选择"
            :right-icon="'arrow'"
            :value="teacherText"
            @click.stop="choiceAttendClassTeacher"
          />

          <div class="vclw van-hairline--bottom">
            <van-cell class="vcl" :title="`老师授课${lessonUnit}数`" :border="false">
              <template>
                <van-stepper
                  default-value="1"
                  min="0.5"
                  max="99999"
                  input-width="60"
                  step="0.5"
                  :decimal-length="1"
                  v-model="params.courseAmount"
                />
              </template>
            </van-cell>
            <div class="vcltip">
              老师上课后按照此处设置统计工作量；学员点名时默认按照此处设置进行扣费（可点名时手动调整）。
            </div>
          </div>

          <van-field
            readonly
            clickable
            input-align="right"
            label="助教"
            placeholder="请选择"
            :right-icon="'arrow'"
            :value="assistantTeacherText"
            @click.stop="choiceAssitantTeacher"
          />
          <van-field
            readonly
            clickable
            input-align="right"
            label="上课教室"
            placeholder="请选择"
            :right-icon="'arrow'"
            v-model="params.classRoomName"
            @click.stop="chooseClassroom()"
          />
        </div>
        <div class="block">
          <div class="block-title">上课内容</div>
          <van-field
            v-model="params.courseContent"
            rows="5"
            input-align="left"
            type="textarea"
            maxlength="500"
            placeholder="将在家长端课表中展示（若每节排课的上课内容不同，请排课成功后再单独添加）"
            show-word-limit
          />
        </div>
        <div class="block">
          <div class="block-title">备注</div>
          <van-field
            v-model="params.courseArrangeRemark"
            rows="5"
            input-align="left"
            type="textarea"
            maxlength="500"
            placeholder="不会展示在家长端，仅本机构老师可见"
            show-word-limit
          />
        </div>
        <div class="block">
          <div class="vclw van-hairline--bottom">
            <van-cell
              class="vcl"
              :border="false"
              v-if="formPage !== 'reserve' && app.permission.op('add_course_reserve')"
              value-class="open-reserve-value-colum"
              title="允许学员约课"
            >
              <template>
                <div class="check-teacher-switch">
                  <van-switch v-model="params.enableReserve" size="24" />
                </div>
              </template>
            </van-cell>
            <div class="vcltip">
              开启后，报读了此课程的学员可通过约课来上课，已经在排课中的学员无需约课。
            </div>
          </div>

          <template v-if="params.enableReserve">
            <van-field
              label-width="140"
              input-align="right"
              required
              type="digit"
              label="可约课学员数"
            >
              <template #input>
                <van-stepper
                  default-value="1"
                  min="1"
                  max="9999"
                  input-width="60"
                  integer
                  v-model="params.studentNum"
                />
              </template>
            </van-field>
            <van-cell
              :border="false"
              class="switch-cell"
              v-if="formPage === 'reserve' || coursePlanType === 1"
            >
              <template #title>
                <div class="check-teacher">设置开课限制</div>
              </template>
              <template>
                <div class="check-teacher-switch">
                  <van-switch v-model="courseOpenStudentSetting" size="24" />
                </div>
              </template>
            </van-cell>

            <div class="vclw van-hairline--bottom" v-if="courseOpenStudentSetting">
              <van-cell class="vcl" title="开课学员数" :border="false">
                <template>
                  <van-stepper
                    default-value="1"
                    min="1"
                    integer
                    max="9999"
                    input-width="60"
                    v-model="courseOpenStudentNum"
                  />
                </template>
              </van-cell>
              <div class="vcltip">排课中的学员数，未达到开课学员数，将会取消排课</div>
            </div>
          </template>
        </div>

        <div class="vclw van-hairline--bottom" v-if="params.enableReserve">
          <van-cell
            class="vcl"
            title="约课规则"
            :border="false"
            is-link
            @click="toEditReserveRules"
          >
            <template>
              <span v-if="courseReserveRule">已设置</span>
              <span v-else style="color: var(--g6)">去设置</span>
            </template>
          </van-cell>
          <div class="vcltip">不设置则使用默认规则发布约课</div>
        </div>

        <div class="block" v-if="params.enableReserve">
          <van-field
            v-model="params.remark"
            rows="5"
            input-align="left"
            type="textarea"
            maxlength="500"
            placeholder="请输入备注选项，备注将在学员约课时展示"
            show-word-limit
          />
        </div>
      </van-form>
    </div>
    <page-footer-btn multipleBtns>
      <van-button
        square
        round
        block
        type="primary"
        @click="submit"
        loading-text="保存中..."
        :loading="submiting"
        data-test="add-communication-page-btn-save"
      >
        保存
      </van-button>
    </page-footer-btn>
    <!-- <van-popup
      class="show-choosed-student-popup"
      v-model="showPopup"
      position="bottom"
      closeable
      :style="{ height: '372px' }"
    >
      <div class="title">已选学员({{ studentIds.length }})</div>
      <div class="body">
        <div v-for="{ id, name } of studentObjs" :key="id">
          {{ name }}
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import paikeDate from './children/paike-date.vue';
import weekPaikeDate from './children/week-paike-date.vue';
import paikeCourseFirst from './children/paike-course-first.vue';
import paikeStudentFirst from './children/paike-student-first.vue';
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

let defaultParams = {
  campusId: app.teacher.campus.id,
  campusName: app.teacher.campus.name,
  curriculumId: '',
  curriculumName: '',
  // 排课时段类型 0:按周设置 1:按天设置
  courseTimeType: 1,
  courseAmount: 1,
  classRoomName: '',
  classRoomId: '',
  teacherList: [],
  assistantTeacherList: [],
  checkConflict: true,
  enableReserve: false,
  studentNum: 1,
  courseContent: '',
  remark: '',
  courseArrangeRemark: ''
};

function getDefaultDailyDatas($vxRoute) {
  let isQuick = !!$vxRoute.query.isQuick;
  if (isQuick) {
    return [
      {
        courseDateList: [new Date()],
        courseTimeRangeList: [
          {
            startTime: '',
            endTime: '',
          },
        ],
      },
    ];
  } else {
    return [
      {
        courseDateList: [],
        courseTimeRangeList: [],
      },
    ];
  }
}
function getDefaultWeeklyDatas() {
  return {
    times: [
      {
        startTime: '',
        endTime: '',
        weekdayName: '',
        weekday: '',
      },
    ],
    endDate: '',
    startDate: '',
    repeatType: '1',
    repeatEndType: '0',
    lessonCount: 1,
  };
}

export default {
  name: 'newAddPaike',
  components: {
    paikeDate,
    weekPaikeDate,
    paikeCourseFirst,
    paikeStudentFirst,
    pageFooterBtn,
  },
  data() {
    const lsType = app.ls.get('x3-paike-add-type');
    const lsMode = app.ls.get('x3-paike-add-mode');
    return {
      pageTitle: '新增排课',
      formPage: this.$vxRoute.query.formPage,
      classId: this.$vxRoute.query.classId,
      // 从班级进入排课, 排课成功直接back
      // 否则要跳转到班级详情
      fromClass: this.$vxRoute.query.fromClass,
      // 是否为快速排课
      isQuick: !!this.$vxRoute.query.isQuick,
      submiting: false,
      studentIds: [],
      studentObjs: [],
      // 排课类型 0：按班级 1：按学员
      coursePlanType: lsType == undefined ? 1 : lsType,
      // 排课方式：0：先选课程 1：先选学员
      coursePlanMode: (this.$vxRoute.query.formPage == 'reserve'||lsMode == undefined) ? 0 : lsMode,
      params: {
        ...JSON.parse(JSON.stringify(defaultParams)),
      },
      dailyPlanDetailList: [...getDefaultDailyDatas(this.$vxRoute)],
      weeklyPlanDetailList: { ...getDefaultWeeklyDatas() },
      classInfo: {},
      // showPopup: false,
      campusList: [app.teacher.campus],
      courseOpenStudentSetting: false,
      courseOpenStudentNum: 1,
      courseReserveRule: null,
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    teacherText() {
      let cpc = this.params.teacherList;
      if (cpc.length == 1) {
        return cpc[0].teacherName;
      } else if (cpc.length > 1) {
        return `${cpc.length}个老师`;
      }
      return '';
    },
    assistantTeacherText() {
      let cpc = this.params.assistantTeacherList;
      if (cpc.length == 1) {
        return cpc[0].name || cpc[0].teacherName;
      } else if (cpc.length > 1) {
        return `${cpc.length}个助教`;
      }
      return '';
    },
  },
  methods: {
    changeCoursePlanType(val){
      this.coursePlanType = val;
      app.ls.set('x3-paike-add-type', val);
    },
    changeCoursePlanMode(val) {
      app.ls.set('x3-paike-add-mode', val);
    },
    render() {
      if (this.classId) {
        this.coursePlanType = 0;
        this.queryClassInfos(this.classId);
      }

      if (this.formPage == 'reserve') {
        this.coursePlanType = 1;
      }
    },
    // 获取班级信息
    async queryClassInfos(classId) {
      this.showLoading();
      let res = await this.$api.getClassInfo({
        classId,
      });
      if (res.code == 200) {
        this.setClassFormItems(res.data);
        this.$toast.clear();
      }
    },
    // 选择班级/获取班级信息后，重设表单信息
    setClassFormItems(info) {
      this.classInfo = info;
      this.params.classId = info.id;
      if (info.classTimeVoList && info.classTimeVoList.length > 0) {
        this.params.courseArrangePlanDetailRoList = info.classTimeVoList;
      }      
      this.params.curriculumId = info.curriculumId;
      this.params.classRoomId = info.classRoomId;
      this.params.classRoomName = info.classRoomName;
      if (this.params.teacherList.length == 0 && info.classTeachers.length > 0) {
        this.params.teacherList = [info.classTeachers[0]];
      }
      if (this.params.assistantTeacherList.length == 0) {
        if (info.classAssistants) {
          this.params.assistantTeacherList = info.classAssistants.map(item => {
            return {
              teacherId: item.teacherId,
              id: item.teacherId,
              name: item.teacherName
            }
          })
        } else {
          this.params.assistantTeacherList = [];
        }
      }
      if (info.planOpenClassTime && this.$route.query.isFromAdd) {
        this.weeklyPlanDetailList.startDate = info.planOpenClassTime;
      }
      this.fillClassTimes(info);
    },
    // 选择班级/获取班级信息后，重设表单信息
    fillClassTimes(info) {
      if (!info.classTimeVoList) {
        return false;
      }
      if (!info.classTimeVoList.length) {
        return false;
      }
      for (const timesOpts of this.weeklyPlanDetailList.times) {
        if (timesOpts.startTime || timesOpts.endTime || timesOpts.weekday) return false;
      }
      this.weeklyPlanDetailList.times.splice(0);
      this.weeklyPlanDetailList.times.push(...JSON.parse(JSON.stringify(info.classTimeVoList)));      
    },
    // 选择班级
    async selectClass() {
      // 从班级进入排课时, 禁用班级选择;
      if (this.classId) return false;
      let classInfo = await app.x3.side.xsClass({
        id: this.classInfo.id,
        params: {
          campusIds: [app.teacher.campusId],
          campusList: [app.teacher.campus],
          classStatus: 0,
        },
        config: {
          radio: true,
          enableFilter: true,
        },
        filter: {
          enableCampusFilter: true,
          enableTeacherFilter: true,
        },
      });

      if (!classInfo) this.classInfo = null;
      // 不支持选空清空选择，选择班级有变化才更新
      if (classInfo && this.classInfo.id !== classInfo.id) {
        this.classInfo = classInfo && classInfo.id ? classInfo : {};
        this.params.campusId = classInfo.campusId;
        this.params.campusName = classInfo.campusName;
        this.queryClassInfos(classInfo.id);
      }
    },
    // 选择教室
    async chooseClassroom() {
      let { coursePlanType } = this;
      let { campusId } = this.params;

      // 按班级排课，必须选了班级才能选教室
      if (coursePlanType === 0 && !this.classInfo.campusId) {
        this.$toast('请选择排课班级');
        return false;
      }
      // 按学员排课，必须选了班级才能选教室
      if (coursePlanType === 1 && !campusId) {
        this.$toast('请选择排课校区');
        return false;
      }
      let paramsCampusId = coursePlanType === 1 ? campusId : this.classInfo.campusId;
      let res = await app.x3.side.xsClassroomChecking({
        id: this.params.classRoomId,
        config: {
          enableAdd: true,
        },
        params: {
          checkConflictType: 1,
          ...this.getSubmitParams(),
          campusIds: [paramsCampusId],
          status: 1,
        },
      });
      this.params.classRoomId = res ? res.id : '';
      this.params.classRoomName = res ? res.roomName : '';
    },
    // 选择上课老师
    async choiceAttendClassTeacher() {
      // 按班级排课，必须选了班级才能选教室
      let { coursePlanType } = this;
      let { campusId } = this.params;
      if (coursePlanType === 0 && !this.classInfo.campusId) {
        this.$toast('请选择排课班级');
        return false;
      }
      let paramsCampusId = coursePlanType === 1 ? campusId : this.classInfo.campusId;
      let res = await app.x3.side.xsTeacherChecking({
        id: this.params.teacherList[0] ? this.params.teacherList[0].teacherId : '',
        config: {
          enableAdd: true,
        },
        params: {
          checkConflictType: 1,
          ...this.getSubmitParams(),
          campusIds: [paramsCampusId],
          statusList: [1],
        },
      });

      if (res) {
        this.params.teacherList = [
          {
            teacherId: res.id,
            teacherName: res.name,
            teacherRule: 0,
          },
        ];
      } else {
        this.params.teacherList = [];
      }
    },
    // 选择助教
    async choiceAssitantTeacher() {
      let { coursePlanType } = this;
      let { campusId } = this.params;
      if (coursePlanType === 0 && !this.classInfo.campusId) {
        this.$toast('请选择排课班级');
        return false;
      }
      let paramsCampusId = coursePlanType === 1 ? campusId : this.classInfo.campusId;
      let res = await app.x3.side.xsTeacher({
        ids: this.params.assistantTeacherList.map(v => v.teacherId),
        list: this.params.assistantTeacherList.map(itm => {
          itm.name = itm.teacherName || itm.name
          return itm
        }),
        config: {
          enableAdd: true,
        },
        params: {
          campusIds: [paramsCampusId],
          statusList: [1],
        },
      });

      this.params.assistantTeacherList = res ? res.list : [];
    },
    //选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        id: this.params.campusId,
        config: {
          must: true,
        },
      });

      this.params.campusId = res.id;
      this.campusList = [res];
      this.params.campusName = res.name;
      this.params.campusId = res.id;
      this.params.campusName = res.name;
      this.$refs.paikeCourseFirstRef.resetCourseStudentInfos();
    },
    courseStudentChange(courseStudentParams) { // 课程学员发生变化时触发
      this.params.curriculumId = courseStudentParams.curriculumId;
      this.params.curriculumName = courseStudentParams.curriculumName;
      this.studentIds = courseStudentParams.studentIds;
      this.studentObjs = courseStudentParams.studentObjs;
    },
    getSubmitParams() {
      let { coursePlanType, courseReserveRule, courseOpenStudentNum, courseOpenStudentSetting } =
        this;
      let {
        courseTimeType,
        classRoomId,
        campusId,
        classId,
        teacherList,
        courseAmount,
        curriculumId,
        checkConflict,
        enableReserve,
        studentNum,
        remark,
        assistantTeacherList,
        courseContent,
        courseArrangeRemark,
      } = this.params;
      let paramsObj = {
        curriculumId: this.params.curriculumId,
        checkConflict,
        campusId,
        classRoomId,
        courseAmount,
        coursePlanType,
        courseTimeType,
        enableReserve,
        courseContent,
        courseArrangeRemark,
      };
      // 按班级单独需要的参数需要的参数
      if (coursePlanType === 0) {
        Object.assign(paramsObj, { classId });
      } else {
        // 按学员排课单独需要的参数
        Object.assign(paramsObj, { studentIds: this.studentIds, curriculumId });
      }

      // 排课时段类型 按周排课单独需要有参数
      if (courseTimeType === 0) {
        let { times, lessonCount, startDate, repeatType, repeatEndType, endDate } =
          this.weeklyPlanDetailList;
        if (!lessonCount) lessonCount = 1;
        let extentParams = {
          weeklyPlanDetailList: times,
          repeatType,
          repeatEndType,
          startTime: app.tool.date.formatDatetime(startDate, 'yyyy-MM-dd'),
        };
        if (repeatEndType === '0') {
          extentParams.lessonCount = repeatType === '0' ? 1 : lessonCount;
        } else {
          extentParams.endTime = app.tool.date.formatDatetime(endDate, 'yyyy-MM-dd');
        }

        Object.assign(paramsObj, extentParams);
      } else {
        // 排课时段类型 按天排课单独需要有参数
        let dailyPlanDetailList = this.dailyPlanDetailList.map(
          ({ courseTimeRangeList, courseDateList }) => ({
            courseDateList: courseDateList.map(v => app.tool.date.formatDatetime(v, 'yyyy-MM-dd')),
            courseTimeRangeList,
          })
        );
        Object.assign(paramsObj, { dailyPlanDetailList });
      }

      if (teacherList[0] && teacherList[0].teacherId) {
        Object.assign(paramsObj, { teacherList });
      }

      // 如果添加了助教，添加助教
      if (assistantTeacherList.length) {
        let assitants = paramsObj.teacherList ? [...paramsObj.teacherList] : [];
        assistantTeacherList.forEach(v => {
          assitants.push({
            teacherId: v.id,
            teacherRule: 1,
          });
        });
        Object.assign(paramsObj, { teacherList: [...assitants] });
      }
      if (enableReserve) {
        Object.assign(paramsObj, { studentNum, remark });
        // 开启开课学员限制，添加限制参数
        if (courseOpenStudentSetting) {
          paramsObj.courseOpenStudentNum = courseOpenStudentNum;
        }

        if (courseReserveRule) {
          paramsObj.courseReserveRule = courseReserveRule;
        }
      }
      return paramsObj;
    },
    submit() {
      let { coursePlanType, studentIds } = this;
      let { courseTimeType, curriculumId, campusId } = this.params;

      // 按班级排课需要校验是否选择班级
      if (coursePlanType === 0) {
        if (!this.classInfo.id) {
          this.$toast('请选择班级');
          return false;
        }
      } else {
        // 按学员排课需要进行的相关校验
        if (!campusId) {
          this.$toast('请选择排课校区');
          return false;
        }
        // 按学员排课需要进行的相关校验
        if (!curriculumId) {
          this.$toast('请选择课程');
          return false;
        }
        if ((!studentIds || !studentIds.length) && this.formPage !== 'reserve') {
          this.$toast('请选择学员');
          return false;
        }
      }

      // 按天排课，检证按天排课格式
      if (courseTimeType === 1) {
        if (!this.$refs['paikeDate'].verify()) {
          return false;
        }
      } else {
        // 按周排课，检证按周排课格式
        if (!this.$refs['weekPaikeDate'].timesVerify()) {
          return false;
        }
      }

      // 提交数据校验
      this.submiting = true;
      this.showLoading();
      this.$api
        .addCourseArrangePlan(this.getSubmitParams())
        .then(res => {
          this.submiting = false;
          if (res.code == 200) {
            this.$toast.clear();
            app.vue.$emit('class-paike-add-success');
            let classId = this.params.classId;
            let { coursePlanType } = this;
            this.initAllParams();
            if (this.formPage === 'reserve') {
              this.$router.back();
              app.vue.$emit('reserve-list-refresh');
              return false;
            }
            setTimeout(() => {
              let { courseArrangeIds } = res.data;
              if (this.isQuick && courseArrangeIds && courseArrangeIds[0]) {
                this.$router.push(`/courseArrange/${courseArrangeIds[0]}`);
                return false;
              }
              // 排课类型 0：按班级 1：按学员
              if (coursePlanType === 1) {
                vant.Dialog.confirm({
                  title: '提示',
                  confirmButtonText: '确定',
                  cancelButtonColor: 'var(--c1)',
                  cancelButtonText: '继续排课',
                  message: '排课成功，可前往课表查看已排课次',
                })
                  .then(res => {
                    if (res === 'confirm') {
                      this.$router.back();
                    }
                  })
                  .catch(err => {
                    console.log(err);
                  });
              } else {
                this.$toast.success('操作成功');
                this.fromClass
                  ? this.$router.back()
                  : this.$router.push('/baseClassDetail/' + classId);
              }
            }, 300);
            return false;
          }
          if (res.code == 830000005) {
            this.$toast.clear();
            // 临时变量，用于存储排课冲突信息，以便在冲突页面展示
            window.__paikeErrData__ = res.data;
            this.$router.push('/classPaiKeErr');
            return false;
          }

          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    initAllParams() {
      // this.coursePlanType = 1;
      this.studentIds.splice(0);
      this.studentObjs.splice(0);
      this.classInfo = {};
      this.params = {
        ...JSON.parse(JSON.stringify(defaultParams)),
      };
      this.dailyPlanDetailList = [...getDefaultDailyDatas(this.$vxRoute)];
      this.weeklyPlanDetailList = { ...getDefaultWeeklyDatas() };
      this.params.teacherList = [];
      this.$refs.paikeCourseFirstRef && this.$refs.paikeCourseFirstRef.resetCourseStudentInfos();
      this.$refs.paikeStudentFirstRef && this.$refs.paikeStudentFirstRef.resetCourseStudentInfos();
    },
    toEditReserveRules() {
      window.__courseReserveRule__ = this.courseReserveRule;
      this.$router.push('/reserveRules?to=log');
    },
  },
  created() {
    this.render();
    this.$onBus('class-paike-continue', () => {
      this.params.checkConflict = false;
      this.submit();
      this.params.checkConflict = true;
    });
    this.$onBus('reserve-rules-change', v => {
      this.courseReserveRule = v;
    });
    this.params.enableReserve =
      this.formPage === 'reserve' && app.permission.op('add_course_reserve');
  },
  watch: {
    // 排课类型变化，需要切换校区信息
    // 排课类型 0：按班级 1：按学员
    coursePlanType: {
      immediate: true,
      handler(v) {
        if (v === 1) {
          this.params.campusId = app.teacher.campus.id;
          this.params.campusName = app.teacher.campus.name;
          if (this.$refs.paikeCourseFirstRef) {
            this.$refs.paikeCourseFirstRef.resetCourseStudentInfos();
          }
          if (this.$refs.paikeStudentFirstRef) {
            this.$refs.paikeStudentFirstRef.resetCourseStudentInfos();
          }
        } else {
          this.params.campusId = '';
          this.params.campusName = '';
          this.courseOpenStudentSetting = false;
          // 切换按班级排课且不是快速排课，默认切换按周排课
          !this.isQuick && (this.params.courseTimeType = 0);
        }
      },
    },
    // 校区id发生变化，需要清空教室信息
    'params.campusId': {
      handler() {
        this.params.classRoomName = '';
        this.params.classRoomId = '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.yunxiao.class.new-add-paike {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    .desc-top {
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g6);
      padding: 8px 16px;
    }
    .course-num-lable {
      display: flex;
      align-items: center;
      height: 100%;
      > span,
      > span > span {
        height: var(--fs-md);
        line-height: var(--fs-md);
      }
    }
    .abc {
      flex: unset;
      width: calc(var(--w) * 100);
    }

    // span.tag {
    //   display: inline-block;
    //   margin-right: calc(var(--gap) * 4);
    //   font-size: var(--fs-sm);
    //   line-height: var(--lh-sm);
    //   padding: calc(var(--gap) * 1) calc(var(--gap) * 4);
    //   border-radius: 2px;
    //   white-space: nowrap;
    //   color: var(--c4);
    //   background: rgba(var(--c4-rgb), 0.15);
    // }
    .paike-type-btns {
      display: flex;
      width: calc(var(--w) * 176);
      height: calc(var(--w) * 32);
      font-size: var(--fs-md);
      font-weight: 400;
      color: var(--g8);
      background: var(--g1);
      border-radius: var(--radius-base);
      border: 1px solid var(--g3);
      overflow: hidden;
      > div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-base);
        &.active {
          color: var(--white);
          background: var(--c1);
        }
      }
    }
    .block {
      margin: calc(var(--gap) * 12) 0;
      &:first-child {
        margin-top: 0;
      }
      // &.linear-gradient {
      //   position: relative;
      //   &::after {
      //     position: absolute;
      //     width: 100%;
      //     display: block;
      //     content: '';
      //     height: calc(var(--w) * 40);
      //     background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      //   }
      // }
      // &.linear-gradient + div {
      //   position: relative;
      //   z-index: 2;
      // }
      .block-title {
        color: var(--g7);
        background-color: var(--white);
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
      }
    }
    .l1 {
      color: var(--g8);
      &.gray {
        color: var(--g6);
      }
    }
    .field-tips {
      padding-top: calc(var(--gap) * 4);
      text-align: right;
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      white-space: normal;
    }
  }
  .show-choosed-student-popup {
    display: flex;
    flex-direction: column;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    color: var(--g8);
    > .title {
      margin-bottom: calc(var(--gap) * 8);
      height: calc(var(--w) * 48);
      font-size: var(--fs-lg);
      line-height: calc(var(--w) * 48);
      font-weight: 500;
      text-align: center;
    }
    > .body {
      padding: 0 calc(var(--gap) * 16);
      overflow: auto;
      > div {
        display: inline-block;
        margin-bottom: calc(var(--gap) * 16);
        width: 50%;
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
      }
    }
  }
}
.vclw {
  padding: calc(var(--gap) * 15) calc(var(--gap) * 16);
  background: var(--white);
  .vcl {
    padding: 0;
  }
  .vcltip {
    padding-top: calc(var(--gap) * 8);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
  }
}
</style>
<style lang="scss">
.yunxiao.class.new-add-paike {
  .main {
    .van-cell__value,
    .van-cell__title,
    .van-field__label,
    .van-field__value {
      color: var(--g8);
    }
    .van-cell__title,
    .van-field__label {
      color: var(--g7);
    }
  }
  .open-reserve-value-colum {
    margin-left: calc(var(--gap) * 24);
    flex: unset;
  }
}
</style>